import cx from 'classnames'

export const MONTHS_IN_YEAR = 12

const getVerticalClass = ({className, isVertical, isFullwidth}) => {
  return cx(className, {
    [`${className}--vertical`]: isVertical,
    [`${className}--fullwidth`]: isFullwidth
  })
}

const getWithoutClass = ({className, isWithout}) => {
  return cx(className, {
    [`${className}--without`]: isWithout
  })
}

const getExtendedClass = ({warranty, vertical, highlighted}) => {
  return cx('mt-CardAdPrice-extended', {
    'mt-CardAdPrice-extended--warranty': warranty,
    'mt-CardAdPrice-extended--vertical': vertical,
    isHighlighted: highlighted
  })
}

const getWarrantyPeriod = ({i18n, months, forceMonths = false}) => {
  if (forceMonths && !months) return `- ${i18n.t('COMMON.PLURALS.MONTH', 1)}`
  if (forceMonths) return i18n.t('COMMON_N_MONTHS', months)
  if (!months) return `- ${i18n.t('COMMON.PLURALS.YEAR', 1)}`

  const showYear = months % MONTHS_IN_YEAR === 0
  return showYear ? i18n.t('COMMON_N_YEARS', months / MONTHS_IN_YEAR) : i18n.t('COMMON_N_MONTHS', months)
}

const getFinancedPriceClass = notAvailableInstalment => {
  return cx('mt-CardAdPrice-financedAmount', {
    'mt-CardAdPrice-financedAmount--withoutInstalment': notAvailableInstalment
  })
}

// format number to locale DE, because it separates thousands of 4 digits with dot
const getValueFormated = value =>
  Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(value)

export {getVerticalClass, getWithoutClass, getExtendedClass, getWarrantyPeriod, getFinancedPriceClass, getValueFormated}
